export enum FeedbackCategory {
  Remark = 'REMARK',
  Roadmap = 'ROADMAP',
  Bug = 'BUG',
  Complaint = 'COMPLAINT',
  Compliment = 'COMPLIMENT',
}
